export default "__VITE_ASSET__eab95526__"